module.exports = __webpack_public_path__ + "img/landscape-left-image.170c2be5.svg";